import { render, staticRenderFns } from "./RealNameReview.vue?vue&type=template&id=fbafc744&scoped=true"
import script from "./RealNameReview.vue?vue&type=script&lang=js"
export * from "./RealNameReview.vue?vue&type=script&lang=js"
import style0 from "./RealNameReview.vue?vue&type=style&index=0&id=fbafc744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbafc744",
  null
  
)

export default component.exports